import { useEffect, useState } from 'react';
import { oauth2Service } from '../../infrastructure/api/oauth2.service';
import { authApi } from '../../infrastructure/api/auth.api';
import { useAuthStore } from '@/shared/infrastructure/stores/authStore';

/**
 * Hook para inicializar la autenticación al cargar la aplicación
 * Restaura la sesión desde el refresh token si existe
 */
export function useAuthInit() {
  const [isInitializing, setIsInitializing] = useState(true);
  const { setUser, setLoading } = useAuthStore();

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        setLoading(true);
        
        // Intentar restaurar sesión desde refresh token
        const tokens = await oauth2Service.restoreSession();
        
        if (tokens) {
          // Si se restauró la sesión, obtener información del usuario
          const user = await authApi.getCurrentUser();
          if (user) {
            setUser(user);
          } else {
            // Si no se puede obtener el usuario, limpiar tokens
            oauth2Service.clearTokens();
          }
        }
      } catch (error) {
        console.error('Error al inicializar autenticación:', error);
        // Limpiar tokens si hay error
        oauth2Service.clearTokens();
      } finally {
        setIsInitializing(false);
        setLoading(false);
      }
    };

    initializeAuth();
  }, [setUser, setLoading]);

  return { isInitializing };
}

